import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import useBrowserDimensions from '../../helpers/use-browser-dimensions.js';
import styles from 'shop-views/SuggestedProducts.scss';

var _excluded = ["useClient", "ProductCardComponent", "suggestedProductsQuery"];

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _empty() {}

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _continueIgnored(value) {
  if (value && value.then) {
    return value.then(_empty);
  }
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var SuggestedProducts = _ref => {
  function _client() {
    return _await(client(suggestedProductsQuery), _temp);
  }

  function _temp(upsellData) {
    var upsellProducts = upsellData.upsellProducts;
    var upsellProductItems = upsellProducts.category ? upsellProducts.category : {};
    setUpsellCategory(upsellProductItems);
  }

  var useClient = _ref.useClient,
      ProductCardComponent = _ref.ProductCardComponent,
      suggestedProductsQuery = _ref.suggestedProductsQuery,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useBrowserDimensions = useBrowserDimensions(),
      browserWidth = _useBrowserDimensions.width;

  var client = useClient();
  var isMobile = browserWidth < 800;
  var isTablet = browserWidth >= 800 && browserWidth <= 1056;
  var isDesktop = browserWidth > 1056;

  var _useState = useState({}),
      upsellCategory = _useState[0],
      setUpsellCategory = _useState[1];

  var numberOfProducts = () => {
    switch (true) {
      case isMobile:
        return 2;

      case isTablet:
        return 3;

      case isDesktop:
      default:
        return 4;
    }
  };

  useEffect(() => {
    var fetchUpsellCategory = _async(function () {
      return _continueIgnored(_catch(_client, _empty));
    });

    fetchUpsellCategory();
  }, [suggestedProductsQuery, client]);

  if (!upsellCategory || !upsellCategory.products || upsellCategory.products.items.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", null, upsellCategory.name), /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, upsellCategory.products.items.slice(0, numberOfProducts()).map((p, i) => /*#__PURE__*/React.createElement(ProductCardComponent, _extends({}, rest, {
    key: i,
    product: p,
    className: styles.item,
    position: i
  })))));
};

export { SuggestedProducts };
//# sourceMappingURL=index.js.map
